import React from 'react';
import PropTypes from 'prop-types';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap-5';

import pluralize from 'pluralize';
import { Modal } from 'react-bootstrap-5';
import Select from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import AssociatedProjectSelector from '../tasks/associated_project_selector';
import { Errors } from 'components/ui/errors';

export default class CreateProjectContactRoleModal extends React.Component {
  static propTypes = {
    contactLabel: PropTypes.string.isRequired,
    relationships: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })).isRequired,
    selectedContactCount: PropTypes.number.isRequired,
    shown: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  state = {
    errors: null,
    project: null,
    relationship: this.props.relationships[0]
  }

  handleRelationshipChange = relationship => this.setState({ errors: null, relationship })
  handleProjectSelect = project => this.setState({ errors: null, project })
  handleProjectClear = () => this.setState({ errors: null, project: null })
  canSubmit = () =>  !!this.state.project;

  handleCancel = () => {
    this.setState({
      errors: null,
      project: null
    }, () => {
      this.props.onCancel();
    });
  }

  handleSubmit = () => {
    const { relationships, onSubmit } = this.props;
    const { project, relationship } = this.state;

    this.canSubmit() && onSubmit(project.associatedModelId, relationship.id).then(() => {
      this.setState({ errors: null, project: null, relationship: relationships[0] });
    }).catch(errors => this.setState({ errors }));
  }

  count = withNumber => pluralize(this.props.contactLabel, this.props.selectedContactCount, !!withNumber)

  render() {
    const { shown } = this.props;
    const { errors, project } = this.state;
    return (
      <Modal centered className="lead-modal" show={shown} onHide={this.handleCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Add {this.count(true)} to Project</Modal.Title>
        </Modal.Header>
        <Modal.Body className="form-vertical-field-container">
          {errors && <Errors errors={errors} />}
          {project && project.associatedModelId ? this.renderProjectSelected() : this.renderProjectSelector()}

          <Form.Group className="form-group">
            <label className="form-label">Relationship</label>
            <Select
              name="relationship"
              options={this.props.relationships}
              value={this.state.relationship}
              onChange={this.handleRelationshipChange}
            />
          </Form.Group>

        </Modal.Body>
        <Modal.Footer>
          {this.renderButtons()}
        </Modal.Footer>
      </Modal>
    );
  }

  renderButtons() {
    return (
      <div>
        <button className="btn btn-ghost me-3" onClick={this.handleCancel}>Cancel</button>
        {this.canSubmit() ? this.renderSubmitButton() : this.renderWithTooltip(this.renderSubmitButton(), 'top')}
      </div>
    );
  }

  renderWithTooltip = (button, placement) => {
    const message = !this.state.project && 'Project can not be blank';
    const tooltip = <Tooltip id="disable-save-button">{message}</Tooltip>;

    return (
      <OverlayTrigger overlay={tooltip} placement={placement}>
        <span className="d-inline-block">{button}</span>
      </OverlayTrigger>
    );
  }

  renderSubmitButton() {
    const disabled = !this.canSubmit();
    return (
      <button
        className="btn btn-primary"
        disabled={disabled}
        style={disabled ? { pointerEvents: 'none' } : {}}
        onClick={this.handleSubmit}
      >
        Add {this.count()} to Project
      </button>
    );
  }

  renderProjectSelected() {
    return (
      <span>
        You are about to add <strong>{this.count(true)}</strong> to the following project:
        <div className="mt-2 mb-0 fs-large fw-semibold">
          {this.state.project.name}
          <FontAwesomeIcon
            className="ms-2 text-danger clickable"
            icon={faTimes}
            size="sm"
            onClick={this.handleProjectClear}
          />
        </div>
        <p className="mt-1 mb-2 text-muted">{this.state.project.address}</p>
      </span>
    );
  }

  renderProjectSelector() {
    return (
      <Form.Group>
        <label className="form-label">Select Project</label>
        <AssociatedProjectSelector onModelAdded={this.handleProjectSelect} />
      </Form.Group>
    );
  }
}
